export default [
	{
		code: 'townhomes/single family rentals',
		name: 'Townhomes/Single Family Rentals',
	},
	{
		code: 'garden style',
		name: 'Garden Style',
	},
	{
		code: 'low-rise',
		name: 'Low-Rise',
	},
	{
		code: 'mid-rise',
		name: ' Mid-Rise',
	},
	{
		code: 'high-rise',
		name: 'High-Rise',
	},
]